import { isDebug } from '../utils/env'
const DEBUG = isDebug()
export const baseUrl = DEBUG ? 'https://lego.bybieyang.com' : 'https://lego.bybieyang.com'
const fifthUrl = 'https://5thave-prod.bieyangapp.com'
export const octoUrl = 'https://octo-cn.bybieyang.com'
export const tapestryUrl = `https://tapestry-${DEBUG ? 'dev' : 'prod'}.bybieyang.com`
export const baleenUrl = DEBUG
  ? 'https://baleen-dev.bybieyang.com'
  : 'https://baleen-prod.bybieyang.com'
export interface IApis {
  uploadImg: string
  getProducts: string
  uploadFile: string
  discoverV3: string
  loginUrl: string
  downloadUrl: string
  fifthUrl: string
  octoUrl: string
  baseUrl: string
  uploadJson: string
  baleenUrl: string
  getProductImg: (productId: string) => void
  searchBrands: (text: string) => void
  getCategories: string
  getArticleDetail: (articleId: string) => void
}

const Apis: IApis = {
  uploadImg: baseUrl + '/oss/image',
  uploadFile: baseUrl + '/oss/file',
  getProducts: fifthUrl + '/api/v3/discover/recommendation',
  discoverV3: fifthUrl + '/api/v3/discover',
  loginUrl: fifthUrl + '/api/v1/signin',
  getProductImg: productId => `${fifthUrl}/api/v1/products/${productId}/detail-image`,
  downloadUrl: 'https://bybieyang.com/cn',
  baleenUrl: 'https://baleen-cdn-g.bybieyang.com',
  fifthUrl,
  octoUrl,
  baseUrl,
  uploadJson: baseUrl + '/oss',
  searchBrands: text => {
    text = encodeURIComponent(text)
    return `${fifthUrl}/api/v1/brands?np=${text}&_all=true`
  },
  getCategories: '/api/v2/productcategories',
  getArticleDetail: articleId => `${baleenUrl}/articles/${articleId}`,
}

export default Apis
